<div class="container-fluid px-0" *ngIf="sdkInitTexts">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div *ngIf="errorMessage" class="error-message">
        <pa-message [description]="errorMessage" (messageState)="messageState($event)"></pa-message>
      </div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="rectangle">
        <p class="phone-number">
          <span>{{phoneNumber}}</span></p>
        <p
          class="description">{{this.textService.keyValueMapping('paymentLoginDescription', 'Ödemenizi tamamlamak için Aşağıdaki alana size ait', sdkInitTexts)}}
          <br><span
            class="text-style">{{this.textService.keyValueMapping('paymentLoginDescriptionContinue', 'şifrenizi giriniz.', sdkInitTexts)}}</span>
        </p>
        <form [formGroup]="pinForm" method="POST" (ngSubmit)="checkPin()">
          <div class="col-12 px-0 d-flex">
            <mat-form-field class="input-style">
              <span
                class="place-holder">{{this.textService.keyValueMapping('msgPaymentPinRule', 'Paycell şifrenizi giriniz.', sdkInitTexts)}}</span>
              <a class="forgot-password"
                 [routerLink]="['/notification/forgot-password', trackingId]">{{this.textService.keyValueMapping('forgotPasswordButton', 'Şifremi Unuttum', sdkInitTexts)}}</a>
              <input type="password" pattern="[0-9]*" inputmode="numeric" autocomplete="off" maxlength="6"
                     formControlName="pin" matInput
                     myAutofocus
                     tbOnlyNumber>
              <mat-hint
                class="help-description">{{this.textService.keyValueMapping('passwordSubtext', 'Paycell uygulamasına giriş yaparken kullandığınız şifrenizi giriniz.', sdkInitTexts)}}
              </mat-hint>
              <mat-error
                *ngIf="submitted && pinForm.controls.pin.errors && pinForm.controls.pin.errors.required">
                {{this.textService.keyValueMapping('msgPaymentPin', 'Lütfen Şifrenizi Giriniz.', sdkInitTexts)}}
              </mat-error>
              <mat-error
                *ngIf="submitted && pinForm.controls.pin.errors && pinForm.controls.pin.errors.minlength">
                {{this.textService.keyValueMapping('msgPaymentPinRule', 'Paycell şifrenizi giriniz.', sdkInitTexts)}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 px-0 d-flex">
            <button type="submit" class="button-style"><span
              class="text-style">{{this.textService.keyValueMapping('paymentApprovalContinueButton', 'Ödemeyi Tamamla', sdkInitTexts)}}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
